module.exports = __webpack_public_path__ + "static/imagine-floors-8e88b2bee3aa70039c0feabdb4d3bbaf.jpg";